module.exports = __webpack_public_path__ + "static/img/61.513f16d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/61.jpg
// module id = h113
// module chunks = 0